import React, { useContext} from 'react';
import { Rail, Segment, Tab } from 'semantic-ui-react';
import MinorStore from '../../../app/stores/minorStore';
import MinorBogTab from './MinorBogTab';
import MinorDesignTab from './MinorDesignTab';
import MinorLogTab from './MinorLogTab';
import MinorTaskTab from './MinorTaskTab';

const panes = [
  { menuItem: 'Task', render: () => <MinorTaskTab/> },
  { menuItem: 'BOG', render: () => <MinorBogTab/> },
  { menuItem: 'Photo', render: () => <div>Photo</div> },
  { menuItem: 'Design', render: () => <MinorDesignTab/> },
  { menuItem: 'Log', render: () => <MinorLogTab />  }
];

const MinorTab = () => {
  const minorStore = useContext(MinorStore);
  const { activeDetailTab, setActiveDetailTab} = minorStore;
  return (
    <Tab
      panes={panes}
      onTabChange={(e, data) => setActiveDetailTab(Number(data.activeIndex))}
      defaultActiveIndex={activeDetailTab}
    />
  );
};

export default MinorTab;
